export const emptyAvatarPresets = {
    getAvatarProps: () => ({}),
};
//# sourceMappingURL=avatar.js.map